import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"guestBtn",attrs:{"color":"synaxy","dark":"","small":_vm.isSmall,"large":_vm.isLarge},on:{"click":_vm.continueAsGuestAsked}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }